import React, { memo } from 'react';
import {
  SettingsIcons,
  SquigglyGridIcons,
  ThreeDIcons,
  UserSquareIcons,
} from '../../../../../../icons/icons';
import { ActionButton } from './ActionButton';
import { FilterButtonGroup } from './FilterButtonGroup';
import { GridViewControlsProps } from './interfaces';

export const GridViewControls = memo<GridViewControlsProps>(
  ({
    isAnalyticsFilterOpen,
    handleAnalyticsFilterOpen,
    handleGraphConfig,
    svgActiveTab,
    view3D,
    toggleSvgTab,
    loading,
    toggle3DViewWithReset,
    isAnalytical3D,
    showHeadshots,
    handleHeadshotToggle,
    handlePreQualFilterOpen,
    isPreQualFilterOpen,
    handleCCAFilterOpen,
    isCCAFilterOpen,
  }) => {
    return (
      <>
        <FilterButtonGroup
            onJDClick={handleAnalyticsFilterOpen}
            onPreQualClick={handlePreQualFilterOpen}
            onCCAClick={handleCCAFilterOpen}
            isJDActive={isAnalyticsFilterOpen}
            isPreQualActive={isPreQualFilterOpen}
            isCCAActive={isCCAFilterOpen}
        />

        <ActionButton
            onClick={handleGraphConfig}
            isActive={isAnalytical3D}
            icon={
              <SquigglyGridIcons className='w-3.5 h-3.5 transition-transform duration-200' />
            }
            label='Graph'
            title='Configure graph settings'
        />

        <ActionButton
            onClick={toggleSvgTab}
            disabled={view3D}
            isActive={svgActiveTab === 3}
            icon={
              <SettingsIcons className='w-3.5 h-3.5 transition-transform duration-200' />
            }
            label='Actions'
            title='Chart actions and tools'
        />

        <ActionButton
            onClick={handleHeadshotToggle}
            isActive={showHeadshots}
            variant='blue'
            icon={
              <UserSquareIcons className='w-3.5 h-3.5 transition-transform duration-200' />
            }
            label='Headshot'
            title='Toggle between image avatars and text-based avatars'
        />

        <div className='w-px h-5 bg-slate-300/60 mx-0.5' />

        <ActionButton
            onClick={toggle3DViewWithReset}
            disabled={loading}
            isActive={view3D}
            variant='purple'
            icon={
              <ThreeDIcons className='w-3.5 h-3.5 transition-transform duration-200' />
            }
            label='3D'
            title='Toggle 3D visualization'
            hideOnSmall
        />
      </>
    );
  },
);

GridViewControls.displayName = 'GridViewControls';
